// extracted by mini-css-extract-plugin
export default {"root":"_3pOFo","theme-based":"_32Y3v","themeBased":"_32Y3v","content":"v1ekQ"};